/* Aura – accessibilità: modali con focus trap, Esc, ritorno del focus, menu mobile, annunci per screen reader. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var stack = [];
  function focusables(el) { return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; }); }
  function openModal(modal, trigger) {
    if (!modal || stack.indexOf(modal) > -1) return;
    modal._trigger = trigger || document.activeElement;
    modal.hidden = false;
    stack.push(modal);
    document.documentElement.classList.add('has-modal');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var f = modal.querySelector('[data-modal-initial-focus]') || focusables(modal)[0] || modal.querySelector('[tabindex="-1"]');
      if (f) f.focus();
    });
    modal.dispatchEvent(new CustomEvent('aura:modal-open', { bubbles: true }));
  }
  function closeModal(modal) {
    modal = modal || stack[stack.length - 1];
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    stack = stack.filter(function (m) { return m !== modal; });
    if (!stack.length) document.documentElement.classList.remove('has-modal');
    var t = modal._trigger;
    if (t && document.contains(t) && t.focus) t.focus();
    modal.dispatchEvent(new CustomEvent('aura:modal-close', { bubbles: true }));
  }
  document.addEventListener('keydown', function (e) {
    var m = stack[stack.length - 1];
    if (!m) return;
    if (e.key === 'Escape') { e.preventDefault(); closeModal(m); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(m);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !m.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !m.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-modal-close]');
    if (c) closeModal(c.closest('.aura-modal,.aura-drawer'));
  });
  function announce(msg) {
    var r = document.getElementById('AuraLiveRegion');
    if (!r) return;
    r.textContent = '';
    setTimeout(function () { r.textContent = msg; }, 60);
  }
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  var overlay = document.querySelector('[data-mobile-nav-overlay]');
  function setNav(open) {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('has-modal', open);
    if (toggle) { toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu'); }
    if (open) { var l = nav.querySelector('a,button'); if (l) l.focus(); }
  }
  if (toggle && nav) toggle.addEventListener('click', function () { setNav(!nav.classList.contains('is-open')); });
  if (overlay) overlay.addEventListener('click', function () { setNav(false); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-mobile-nav-close]')) { setNav(false); if (toggle) toggle.focus(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) { setNav(false); if (toggle) toggle.focus(); } });
  window.AuraA11y = { openModal: openModal, closeModal: closeModal, announce: announce };
})();
